import React, { useState, useEffect } from 'react';
import AdminPanel from './AdminPannel';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const Dashboard = () => {
  const [websiteVisits, setWebsiteVisits] = useState([
    { month: 'Jan', visits: 100 },
    { month: 'Feb', visits: 120 },
    { month: 'Mar', visits: 95 },
    { month: 'Apr', visits: 150 },
    { month: 'May', visits: 130 },
  ]);
  const [sales, setSales] = useState(50);
  const [users, setUsers] = useState(120);
  const [ordersCount, setOrdersCount] = useState(75);
  const [showGraph, setShowGraph] = useState(true);
  const [graphType, setGraphType] = useState('line');
  const [userDetails, setUserDetails] = useState(null);
  const [userList, setUserList] = useState([
    { id: 1, name: 'Alice', email: 'alice@example.com', joined: '2024-01-15' },
    { id: 2, name: 'Bob', email: 'bob@example.com', joined: '2024-03-20' },
    { id: 3, name: 'Charlie', email: 'charlie@example.com', joined: '2024-05-01' },
    { id: 4, name: 'David', email: 'david@example.com', joined: '2024-07-10' },
    { id: 5, name: 'Eve', email: 'eve@example.com', joined: '2024-09-25' },
  ]);
  const [allOrderList, setAllOrderList] = useState([
    { id: 'ORD001', customer: 'Alice', date: '2025-05-10', total: 45.99, status: 'Shipped' },
    { id: 'ORD002', customer: 'Bob', date: '2025-05-11', total: 120.50, status: 'Processing' },
    { id: 'ORD003', customer: 'Charlie', date: '2025-05-11', total: 78.20, status: 'Delivered' },
    { id: 'ORD004', customer: 'David', date: '2025-05-12', total: 22.75, status: 'Pending' },
    { id: 'ORD005', customer: 'Eve', date: '2025-05-13', total: 95.00, status: 'Shipped' },
    { id: 'ORD006', customer: 'Alice', date: '2025-05-13', total: 150.00, status: 'Delivered' },
    { id: 'ORD007', customer: 'Bob', date: '2025-05-14', total: 30.25, status: 'Pending' },
  ]);
  const [filteredOrderList, setFilteredOrderList] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setFilteredOrderList(allOrderList);
  }, [allOrderList]);

  useEffect(() => {
    const interval = setInterval(() => {
      setWebsiteVisits(prev =>
        prev.map(item => ({ ...item, visits: item.visits + Math.floor(Math.random() * 30) - 15 }))
      );
      setSales(prev => prev + Math.floor(Math.random() * 10) - 5);
      setUsers(prev => prev + Math.floor(Math.random() * 5) - 2);
      setOrdersCount(prev => prev + Math.floor(Math.random() * 12) - 6);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const dashboardStyle = {
    backgroundColor: '#f4f4f4',
    padding: '20px',
    fontFamily: 'sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const graphContainerStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    width: '95%',
    maxWidth: '800px',
    height: 'auto',
  };

  const widgetContainerStyle = {
    display: 'flex',
    width: '95%',
    maxWidth: '800px',
    justifyContent: 'space-around',
    marginBottom: '20px',
    flexWrap: 'wrap',
  };

  const widgetStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center',
    flex: '1 1 150px',
    margin: '10px',
  };

  const titleStyle = {
    fontSize: '1.2em',
    color: '#333',
    marginBottom: '10px',
  };

  const valueStyle = {
    fontSize: '1.8em',
    fontWeight: 'bold',
    color: '#007bff',
  };

  const buttonContainerStyle = {
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'center',
  };

  const buttonStyle = {
    padding: '8px 15px',
    margin: '0 5px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '0.9em',
  };

  const showGraphButtonStyle = {
    ...buttonStyle,
    backgroundColor: showGraph ? '#007bff' : '#6c757d',
    color: '#fff',
  };

  const changeGraphTypeButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#28a745',
    color: '#fff',
  };

  const orderTableStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    width: '95%',
    maxWidth: '800px',
    overflowX: 'auto',
  };

  const userTableStyle = {
    ...orderTableStyle,
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
  };

  const thStyle = {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    borderBottom: '1px solid #ddd',
    textAlign: 'left',
  };

  const tdStyle = {
    padding: '8px',
    borderBottom: '1px solid #eee',
  };

  const orderDetailStyle = {
    backgroundColor: '#f9f9f9',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    marginTop: '20px',
    width: '95%',
    maxWidth: '800px',
  };

  const userDetailStyle = {
    ...orderDetailStyle,
  };

  const searchContainerStyle = {
    display: 'flex',
    marginBottom: '15px',
    width: '95%',
    maxWidth: '800px',
  };

  const searchInputStyle = {
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    flexGrow: 1,
    marginRight: '10px',
  };

  const handleUserClick = (user) => {
    setUserDetails(user);
  };

  const handleOrderClick = (order) => {
    setOrderDetails(order);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredOrders = allOrderList.filter(order =>
      order.id.toLowerCase().includes(query) ||
      order.customer.toLowerCase().includes(query) ||
      order.date.toLowerCase().includes(query) ||
      order.status.toLowerCase().includes(query)
    );
    setFilteredOrderList(filteredOrders);
  };

  return (
    <div style={dashboardStyle}>
      <AdminPanel />
      <h1 style={{ fontSize: '2em', color: '#333', marginBottom: '20px', textAlign: 'center' }}>Simple Dashboard</h1>

      <div style={buttonContainerStyle}>
        <button style={showGraphButtonStyle} onClick={() => setShowGraph(!showGraph)}>
          {showGraph ? 'Hide Graph' : 'Show Graph'}
        </button>
        {showGraph && (
          <button
            style={changeGraphTypeButtonStyle}
            onClick={() => setGraphType(graphType === 'line' ? 'bar' : 'line')}
          >
            Change to {graphType === 'line' ? 'Bar Chart' : 'Line Chart'}
          </button>
        )}
      </div>

      {showGraph && (
        <div style={graphContainerStyle}>
          <h2 style={{ ...titleStyle, textAlign: 'center' }}>Website Visits Trend</h2>
          <ResponsiveContainer width="100%" height={250}>
            {graphType === 'line' ? (
              <LineChart data={websiteVisits}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="visits" stroke="#82ca9d" strokeWidth={2} />
              </LineChart>
            ) : (
              <BarChart data={websiteVisits}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="visits" fill="#8884d8" />
              </BarChart>
            )}
          </ResponsiveContainer>
        </div>
      )}

      <div style={widgetContainerStyle}>
        <div style={widgetStyle}>
          <h2 style={titleStyle}>Sales</h2>
          <p style={valueStyle}>{sales}</p>
        </div>
        <div style={widgetStyle}>
          <h2 style={titleStyle}>Active Users</h2>
          <p style={valueStyle}>{users}</p>
        </div>
        <div style={widgetStyle}>
          <h2 style={titleStyle}>Orders</h2>
          <p style={valueStyle}>{ordersCount}</p>
        </div>
      </div>

      {/* Order Table */}
      <div style={orderTableStyle}>
        <h2 style={titleStyle}>Order List</h2>
        <div style={searchContainerStyle}>
          <input
            type="text"
            style={searchInputStyle}
            placeholder="Search orders..."
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Order ID</th>
              <th style={thStyle}>Customer</th>
              <th style={thStyle}>Order Date</th>
              <th style={thStyle}>Total</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrderList.map(order => (
              <tr key={order.id} onClick={() => handleOrderClick(order)} style={{ cursor: 'pointer' }}>
                <td style={tdStyle}>{order.id}</td>
                <td style={tdStyle}>{order.customer}</td>
                <td style={tdStyle}>{order.date}</td>
                <td style={tdStyle}>${order.total.toFixed(2)}</td>
                <td style={tdStyle}>{order.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Order Details */}
      {orderDetails && (
        <div style={orderDetailStyle}>
          <h2 style={titleStyle}>Order Details</h2>
          <p><strong>Order ID:</strong> {orderDetails.id}</p>
          <p><strong>Customer:</strong> {orderDetails.customer}</p>
          <p><strong>Order Date:</strong> {orderDetails.date}</p>
          <p><strong>Total:</strong> ${orderDetails.total.toFixed(2)}</p>
          <p><strong>Status:</strong> {orderDetails.status}</p>
        </div>
      )}

      {/* User Table */}
      <div style={userTableStyle}>
        <h2 style={titleStyle}>User List</h2>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Joined Date</th>
            </tr>
          </thead>
          <tbody>
            {userList.map(user => (
              <tr key={user.id} onClick={() => handleUserClick(user)} style={{ cursor: 'pointer' }}>
                <td style={tdStyle}>{user.id}</td>
                <td style={tdStyle}>{user.name}</td>
                <td style={tdStyle}>{user.email}</td>
                <td style={tdStyle}>{user.joined}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* User Details */}
      {userDetails && (
        <div style={userDetailStyle}>
          <h2 style={titleStyle}>User Details</h2>
          <p><strong>ID:</strong> {userDetails.id}</p>
          <p><strong>Name:</strong> {userDetails.name}</p>
          <p><strong>Email:</strong> {userDetails.email}</p>
          <p><strong>Joined On:</strong> {userDetails.joined}</p>
        </div>
      )}
    </div>
  );
};

export default Dashboard;